import React from 'react';
import './skeleton.css';

export function Skeleton({ className, style, ...props }) {
  return (
    <div
      className={`skeleton-base ${className || ''}`}
      style={style}
      {...props}
    />
  );
}
